<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="5" style="margin-bottom: 15px">
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="deptData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expand-all="true"
              @node-click="choose"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="19" style="margin-bottom: 15px">
          <codeList ref="codeList" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import codeList from './codeList';
  import { getAllGradeTree } from '@/config/api';

  export default {
    name: 'ClassCode',
    components: { codeList },
    data() {
      return {
        loading: true, // 加载状态
        deptData: [], // 列表数据
      };
    },
    mounted() {
      this.query();
    },
    methods: {
      query() {
        this.loading = true;
        getAllGradeTree().then((res) => {
          this.loading = false;
          if (res.data.resCode == 200) {
            this.deptData.push(res.data.data);
            setTimeout(() => {
              this.choose(this.deptData[0].children[0].children[0]);
            }, 100);
          } else {
            this.$message.error(res.data.resMsg || '获取数据失败');
          }
        });
      },
      /* 选择数据 */
      choose(row) {
        if (row.orgType === 3) {
          this.$refs.orgTree.setCurrentKey(row.id);
          let obj = {
            id: row.id.slice(1),
          };
          this.$refs.codeList.table.where = obj;
          this.$refs.codeList.$refs.table.reload();
        }
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 35px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
